import { NgModule } from '@angular/core';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import En from '../../assets/i18n/en_devel.json';

@NgModule({
  imports: [
    TranslateModule,
    LexiconModule.forChild({
      componentName: 'common/crm',
      baseTranslation: En,
    }),
  ],
  exports: [TranslateModule],
})
export class TranslationModule {}
